import { throttle } from '@/utility/functions';

window.addEventListener('vueloaded', () => {
    if(document.getElementById('history-timeline')) {
        const sliderElements = document.querySelectorAll('.slide-in-parent');
        const headerHeight = Math.floor(document.getElementById('sticky-header').clientHeight);
        const timelineTop = getY(document.getElementById('history-timeline'));

        function getY(el) {
          var y = 0;

          while(el) {
            if (el.tagName == "BODY") {
              y += (el.offsetTop + el.clientTop);
            } else {
              y += (el.offsetTop + el.clientTop);
            }

            el = el.offsetParent;
          }

          return Math.floor(y);
        }

        function checkSlide(e) {
            sliderElements.forEach((sliderElement, i) => {
                const eTop = Math.floor(timelineTop + sliderElement.offsetTop);
                const eBot = eTop + Math.floor(sliderElement.clientHeight);
                const wTop = Math.floor(window.pageYOffset);
                const wBot = Math.floor(wTop + window.innerHeight);

                // don't monitor further if off screen
                if(eTop > wBot || eBot - headerHeight < wTop) {
                    return;
                }

                if(wBot >= eBot && wTop <= eTop - headerHeight) {
                    if(sliderElement.classList.contains('active')) {
                        return;
                    }

                    sliderElement.classList.add('active');
                } else if(i !== 0 || (i === 0 && eBot < wBot)) {
                    if(!sliderElement.classList.contains('active')) {
                        return;
                    }

                    sliderElement.classList.remove('active');
                }
            });
        }

        window.addEventListener('scroll', throttle(checkSlide, 10));

        checkSlide();
    }
});
